import { SPOILER_TYPE, TIPTAP_FIGURE_TYPE, VIDEO_TYPE } from "./../ricos-content/index.js";
import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { createDeleteButton } from "./../_shared/plugin-toolbar/create-delete-button.js";
import { createNodeAlignmentButton } from "./../_shared/plugin-toolbar/create-node-alignment-button.js";
import { createReplaceButton } from "./../_shared/plugin-toolbar/create-replace-button.js";
import { createSettingsButton } from "./../_shared/plugin-toolbar/create-settings-button.js";
import { createNodeSizeButton } from "./../_shared/plugin-toolbar/node-size-button/create-node-size-button.js";
import { createSeparator } from "./../_shared/plugin-toolbar/separator/create-separator.js";
import { FLOATING_PLUGIN_TOOLBAR } from "./../toolbars-v3/index.js";
import { VIDEO_BUTTONS, VIDEO_REPLACE_MODAL_ID, VIDEO_SETTINGS_MODAL_ID } from "./constants.js";
import { InsertModal } from "./modals/InsertModal.js";
import { SettingsModal } from "./modals/SettingsModal.js";
const getToolbarButtons = (config, services) => {
  const { disableDownloadDefault, getVideoUrl } = config || {};
  const { modals } = services;
  const modalBaseProps = {
    disableDownloadDefault,
    getVideoUrl
  };
  const shouldShowSpoiler = () => {
    const spoilerPlugin = services.plugins.asArray().find((plugin) => plugin.getType() === SPOILER_TYPE);
    return spoilerPlugin && (!spoilerPlugin.getConfig().supportedPlugins || spoilerPlugin.getConfig().supportedPlugins.includes(VIDEO_TYPE));
  };
  const settingsVisibilityResolver = {
    id: "IS_VIDEO_SETTINGS_BUTTON_VISIBLE",
    resolve: (content) => {
      if (Array.isArray(content) && content.length > 0) {
        const isCustomVideo = !!content.find((node) => node?.type?.name === Node_Type.VIDEO)?.attrs?.video?.src?.id;
        return shouldShowSpoiler() || isCustomVideo;
      }
      return false;
    }
  };
  return [
    createNodeSizeButton({
      services,
      modalId: VIDEO_BUTTONS.size,
      options: ["SMALL", "CONTENT", "FULL_WIDTH"]
    }),
    createNodeAlignmentButton({ services, modalId: VIDEO_BUTTONS.alignment }),
    createReplaceButton({
      modalId: VIDEO_REPLACE_MODAL_ID,
      command: ({ referenceElement, attributes: { selectedNode } }) => {
        const {
          video: { src },
          id
        } = selectedNode.attrs;
        const videoSrc = src.url ? { url: src.url } : src.id ? { id: src.id } : {};
        modals?.togglePluginPanel({
          id: VIDEO_REPLACE_MODAL_ID,
          Component: InsertModal,
          componentProps: {
            modalId: VIDEO_REPLACE_MODAL_ID,
            componentData: { video: { src: videoSrc } },
            nodeId: id,
            ...modalBaseProps
          },
          isMobile: services.context.isMobile,
          positioning: {
            referenceElement,
            placement: "bottom"
          },
          mobileLayout: "drawer"
        });
      }
    }),
    createSettingsButton({
      modalId: VIDEO_SETTINGS_MODAL_ID,
      command: ({ referenceElement, attributes: { selectedNode } }) => {
        modals?.togglePluginPanel({
          id: VIDEO_SETTINGS_MODAL_ID,
          Component: SettingsModal,
          componentProps: {
            nodeId: selectedNode.attrs.id
          },
          isMobile: services.context.isMobile,
          positioning: {
            referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
            placement: "right-start"
          },
          focusReturnElement: referenceElement
        });
      },
      attributes: {
        visible: settingsVisibilityResolver
      }
    }),
    createSeparator(),
    createDeleteButton({
      command: (data) => {
        const figures = data.tiptapEditor.$nodes(TIPTAP_FIGURE_TYPE);
        const selectedFigure = figures?.find((f) => {
          return f.firstChild?.node.attrs.id === data.attributes.selectedNode.attrs.id;
        });
        if (selectedFigure) {
          data.tiptapEditor.chain().focus().deleteNode(selectedFigure.attributes.id).run();
        }
      }
    })
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
